import axios from '../utils/API'
import { saveInLocalStorage, getFromLocalStorage } from '../helper/storage'
import errorHandler from '../helper/errorHandler'

const signUp = (
  user,
  setAuthError,
  setSignupSuccess,
  Toast,
  cb,
  stopLoader,
) => {
  axios
    .post('user', user)
    .then(res => {
      setAuthError(null)
      setSignupSuccess(
        'You have registered successfully, Password have been sent to your email.',
      )
      Toast('You have registered successfully', {
        appearance: 'success',
        autoDismiss: true,
      })
      cb()
    })
    .catch(e => {
      const { response } = e
      setAuthError(errorHandler(response))
      stopLoader()
    })
}

const editProfile = (userData, user, cb, Toast, setData) => {
  axios
    .put(`user/${userData.id}`, user)
    .then(res => {
      Toast('You have updated your profile successfully.', {
        appearance: 'success',
        autoDismiss: true,
      })
      setData({ ...userData, ...res.data.data })
      saveInLocalStorage('userData:', { ...userData, ...res.data.data })
      cb()
    })
    .catch(e => {
      const { response } = e
      Toast(errorHandler(response), {
        appearance: 'error',
        autoDismiss: true,
      })
      cb()
    })
}
const getAllCampaigns = async user => {
  return await axios.post('get-campaigns-influencer', user)
}

const getUserEvents = (email, setEvents) => {
  const data = {
    token: 'shk73TQUOLPkTl2YZ8vQtvo4sZoENoUx',
    lang: 'en',
    email: email,
  }
  axios.post('userinfo', data).then(res => {
    console.log('res:', res.data)
    if (res.data.status === 'Success') {
      setEvents(res.data.data.events)
    }
  })
}

const login = (cb, user, data, setData, setAuth, setAuthError, stopLoader) => {
  axios
    .post('user/login', user)
    .then(res => {
      data = res.data.data
      setAuth(true)
      setData(data)
      saveInLocalStorage('userData:', data)
      saveInLocalStorage('auth:', true)
      cb()
    })
    .catch(e => {
      const { response } = e
      setAuthError(errorHandler(response))
      stopLoader()
    })
}

const logout = (event, setAuth) => {
  event.preventDefault()
  setAuth(false)
  localStorage.clear()
  window.location.href = '/'
}

const addPricing = (pricing, userData) => {
  return axios.post('update-influencer-pricing', pricing).then(res => {
    try {
      if (res.data.status === 'Success') {
        // use this if pricing grouped in apis
        // userData.pricing = pricing
        for (let p in pricing) userData[p] = pricing[p]
        saveInLocalStorage('userData:', userData)
        //window.location.href = '/dashboard/influencer'
        return true
      } else if (res.data.status === 'Failed') {
        console.error(res.data)
        return res.data.status
      }
    } catch (e) {
      console.log(e)
    }
  })
}

const addTagging = (tagging, userData) => {
  return axios.post('update-influencer-tags', tagging).then(res => {
    try {
      if (res.data.status === 'Success') {
        //userData.tagging = tagging
        for (let t in tagging) userData[t] = tagging[t]
        saveInLocalStorage('userData:', userData)
        //window.location.href = '/dashboard/influencer'
        return true
      } else if (res.data.status === 'Failed') {
        console.error(res.data)
        return false
      }
    } catch (e) {
      console.log(e)
    }
  })
}

const saveSocialMediaData = (platform, data, userData) => {
  return axios
    .post(`save-social-media-data/${platform}`, {
      auth_token: userData.auth_token,
      user_data: data,
    })
    .then(res => {
      try {
        if (res.data.status === 'Success') {
          userData.social_media_data[platform] = data
          saveInLocalStorage('userData:', userData)
          //window.location.href = '/dashboard/influencer'
          return true
        } else if (res.data.status === 'Failed') {
          console.error(res.data)
          return false
        }
      } catch (e) {
        console.log('error', e)
      }
    })
}

const deleteSocialMediaData = (platform, userData) => {
  console.log('userData.auth_token DDD', userData.auth_token)
  return axios
    .post(`delete-social-media-data/${platform}`, {
      auth_token: userData.auth_token,
      user_data: 'delete',
    })
    .then(res => {
      try {
        if (res.data.status === 'Success') {
          userData.social_media_data[platform] = null
          // console.log('deleted ', userData)
          saveInLocalStorage('userData:', userData)
          return true
        } else if (res.data.status === 'Failed') {
          console.error(res.data)
          return false
        }
      } catch (e) {
        console.log('error', e)
      }
    })
}

const makeTitle = slug => {
  var words = slug.split('-')

  for (var i = 0; i < words.length; i++) {
    var word = words[i]
    words[i] = word.charAt(0).toUpperCase() + word.slice(1)
  }

  return words.join(' ')
}
const isAuthenticated = () => {
  getFromLocalStorage('auth:')
}
export {
  signUp,
  login,
  logout,
  isAuthenticated,
  editProfile,
  getUserEvents,
  makeTitle,
  addPricing,
  addTagging,
  saveSocialMediaData,
  getAllCampaigns,
  deleteSocialMediaData,
}
